import { render, staticRenderFns } from "./Invoicemangerjilu.vue?vue&type=template&id=3ec3968e&scoped=true"
import script from "./Invoicemangerjilu.vue?vue&type=script&lang=js"
export * from "./Invoicemangerjilu.vue?vue&type=script&lang=js"
import style0 from "./Invoicemangerjilu.vue?vue&type=style&index=0&id=3ec3968e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec3968e",
  null
  
)

export default component.exports